import script from "./ProjectDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDetails.vue?vue&type=style&index=0&id=5e8c5acb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e8c5acb"]])

export default __exports__